import React from "react";
import {
  StyleSheet,
  View,
  Platform,
  Dimensions,
  Image,
  Text,
  Pressable,
  TouchableOpacity,
  TextInput,
  TouchableHighlight
} from "react-native";
import * as Styles from "../utils/Styles";
import * as Commons from "../utils/Commons";
import * as Constants from "../utils/Constants";
import { Transparent, WHITE, White } from "react-native-material-color";
import { Ionicons, MaterialCommunityIcons } from "@expo/vector-icons";
import { STRINGS } from "../utils/Strings";
import * as Animatable from "react-native-animatable";
import { ScrollView } from "react-native-gesture-handler";

let height = Dimensions.get("window").height;
let width = Dimensions.get("window").width;

const drawerIconImgLight = require("../images/logo.png");
const logo_white = require("../images/logo_white.png");
const arrowTop = require("../images/arrowTop.png");
const arrowTop2 = require("../images/arrowTop2.png");
const closeImg = require("../images/close_white.png");
const hamburgerIcon = require("../images/hamburger.png");
let isMobile = false;
let styles = {};
let isShown = true;
class Header extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      Qty: 0,
      burgerMenuShown: true
    };
  }
  MenuItems = {};

  componentDidMount = async () => {
    // this.setState({ badgeText: this.props.badgeText });
    // let basketItems = await Commons.getFromAS(Constants.basketItems);
    // if (basketItems) {
    //   try {
    //     basketItems = JSON.parse(basketItems);
    //     this.setState({ badgeText: basketItems.length });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // }
  }



  renderMenuItemMobile = (text, title, style) => {
    return (
      <Pressable
        ref={el => (this.MenuItems[text] = el)}>
        <TouchableOpacity onPress={() => {
          if (this.props.onNavigate) this.props.onNavigate();
          this.props.self.zoomLevel = undefined;
          // if (title == "login") {
          //   this.props.navigation.navigate("splash");
          // } else {
          // }
          window.location = './' + title;
        }} style={{ paddingVertical: 23, alignItems: 'center', width }}>
          <Text style={[{ fontFamily: Styles.fontFamily1, color: 'white', fontSize: 30 }, style]}>
            {text}
          </Text>
        </TouchableOpacity>
        <View style={{ background: 'rgba(255, 255, 255, 0.37)', height: 1, marginHorizontal: 20 }} />
      </Pressable>
    )
  }

  renderMenuItem = (text, title) => {
    return (
      <Pressable
        ref={el => (this.MenuItems[text] = el)}
        onHoverIn={() => this.setState({ hoveredComponent: this.MenuItems[text] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity onPress={() => {
          if (this.props.onNavigate) this.props.onNavigate();
          this.props.self.zoomLevel = undefined;
          // this.props.navigation.replace(title, { v: new Date().getSeconds() });
          window.location = './' + title;
        }}>
          <Text style={((this.state.hoveredComponent && this.MenuItems[text] == this.state.hoveredComponent) || this.props.selectedTab == text) ? styles.textStyleHovered : styles.textStyle}>
            {text}
          </Text>
        </TouchableOpacity>
        {/* <View style={((this.props.selectedTab == text) ? styles.selectedScreen : styles.nonSelectedScreen)}></View> */}
      </Pressable>
    )
  }

  renderMobile() {
    return (
      this.state.burgerMenuShown ? this.renderNotExpanded() : this.renderExpanded(false)
    );
  }

  renderHeader(expanded) {
    return (
      expanded != true ? this.renderNotExpanded() : this.renderExpanded()
    )
  }

  render() {
    height = Dimensions.get("window").height;
    width = Dimensions.get("window").width;
    isMobile = Commons.isMobile();
    width = Commons.getWidth();
    if (this.props.hideHeader == isShown && this.headerAnimatable) {
      isShown = !isShown;
      setTimeout(() => {
        if (isShown) {
          this.headerAnimatable.animate({ 0: { marginTop: -89 }, 1: { marginTop: 0 } });
        } else {
          this.headerAnimatable.animate({ 0: { marginTop: 0 }, 1: { marginTop: -89 } });
        }
      }, 0);
    }
    if (isMobile) {
      return this.renderMobile();
    }
    styles = this.styles();

    return (
      [
        <Animatable.View
          ref={el => (this.headerAnimatable = el)}
          duration={250}
          style={[
            styles.container,
            { backgroundColor: WHITE, },
          ]}
        >
          <View style={styles.view}>
            {/* {this.props.leftView} */}
            <TouchableOpacity onPress={() => {
              // this.props.navigation.replace("home");
              window.location = './home';
            }}>
              <Image
                style={{
                  width: 142,
                  height: 44,
                  padding: 1,
                  resizeMode: "contain",
                }}
                source={drawerIconImgLight}
              />
            </TouchableOpacity>

            {this.renderMenuItem(STRINGS.about_us, "aboutus")}
            {this.renderMenuItem(STRINGS.services, "service")}
            {this.renderMenuItem(STRINGS.products, "products")}
            {this.renderMenuItem(STRINGS.careers, "careers")}
            {this.renderMenuItem(STRINGS.contact_us, "contactus")}
            {this.renderMenuItem(STRINGS.pharmacovigilance, "pharmacovigilace")}
          </View>
          <View style={styles.view}>
            {this.renderMenuItem(STRINGS.login, "login")}

          </View>
        </Animatable.View>,
        !this.props.hideScrollTopButton && this.renderScrollToTop()
      ]
    );
  }

  renderNotExpanded() {
    width = Dimensions.get("window").width;
    const styles = this.styles();
    return (
      (
        <View
          style={[
            styles.container,
            {
              backgroundColor: 'white',
              width,
              direction: "ltr"
            },
          ]}
        >
          <View style={styles.view}>
            {/* {this.props.leftView} */}
            <TouchableOpacity onPress={() => { window.location = './home' }}>
              <Image
                style={{
                  width: 96,
                  height: 30,
                  padding: 1,
                  resizeMode: "contain",
                }}
                source={drawerIconImgLight}
              />
            </TouchableOpacity>
          </View>
          <View style={[styles.view, {
            position: "absolute",
            right: 20
          }]}>
            <View style={{ flexDirection: 'row' }}>
              <TouchableOpacity style={{}} onPress={() => this.setState({ burgerMenuShown: false })}>
                <Image
                  style={{
                    width: 25,
                    height: 25,
                    padding: 1,
                    resizeMode: "contain",
                  }}

                  source={hamburgerIcon}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      )
    )
  }

  renderExpanded() {
    var position2 = width - 50;
    var position = width - 105;
    const styles = this.styles();
    width = Dimensions.get("window").width;
    return (
      (
        <ScrollView style={[
          styles.containerMobile,
          { backgroundColor: Styles.appColor1, width, minHeight: height, height },
        ]}
          showsVerticalScrollIndicator={false}>
          <View style={{ flexDirection: 'row', width, direction: "ltr", height: 75, alignItems: "center" }}>
            <TouchableOpacity onPress={() => { window.location = './home' }}>
              <Image
                style={{
                  width: 96,
                  height: 30,
                  marginHorizontal: 18,
                  padding: 1,
                  resizeMode: "contain",
                  alignSelf: "flex-start",
                }}
                source={logo_white}
              />
            </TouchableOpacity>
            <View style={{
              position: "absolute",
              right: 10
            }}>
              <TouchableOpacity style={{ marginHorizontal: 14 }} onPress={() => this.setState({ burgerMenuShown: true })}>
                <Image
                  style={{
                    width: 20,
                    height: 20,
                    marginTop: 2,
                    resizeMode: "contain",
                  }}
                  source={closeImg}
                />
              </TouchableOpacity>
            </View>
          </View>
          <View style={{ marginTop: 20 }}>
            {this.renderMenuItemMobile(STRINGS.about_us, "aboutus")}
            {this.renderMenuItemMobile(STRINGS.services, "service")}
            {this.renderMenuItemMobile(STRINGS.products, "products")}
            {this.renderMenuItemMobile(STRINGS.careers, "careers")}
            {this.renderMenuItemMobile(STRINGS.contact_us, "contactus")}
            {this.renderMenuItemMobile(STRINGS.pharmacovigilance, "pharmacovigilace", {})}
            {this.renderMenuItemMobile(STRINGS.login, "login", {})}
            {this.renderMenuItemMobile("", "", { height: 50 })}
          </View>
        </ScrollView >

      )
    )
  }

  renderScrollToTop = () => {
    const text = 'scrollTopTop'
    return (
      <Pressable
        ref={el => (this.MenuItems[text] = el)}
        style={{ position: "absolute", top: height * 0.66, right: 50, width: 100, height: 100, zIndex: 99 }}
        onHoverIn={() => this.setState({ hoveredComponent: this.MenuItems[text] })}
        onHoverOut={() => this.setState({ hoveredComponent: undefined })} >
        <TouchableOpacity style={{ width: 68.19, height: 68.19 }} onPress={() => {
          this.props.self.mainScrollView.scrollTo({ animated: true, y: 0 });
          // this.props.navigation.navigate("aboutus", { v: new Date().getSeconds() });
        }}>
          <Image source={this.state.hoveredComponent && this.MenuItems[text]
            == this.state.hoveredComponent ? arrowTop2 : arrowTop}
            style={[this.state.hoveredComponent && this.MenuItems[text]
              == this.state.hoveredComponent ?
              {} : {},
            { width: 68, height: 68 }]} />
        </TouchableOpacity>
      </Pressable>
    )
  }

  styles = () => {
    return {
      container: {
        position: "absolute",
        zIndex: 2,
        width,
        height: 89,
        paddingVertical: 13.5,
        paddingHorizontal: isMobile ? 18 : 50,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: WHITE
      },
      containerMobile: {
        position: "absolute",
        zIndex: 2,
        width: width,
        minHeight: '100%',
        elevation: 8,
        paddingTop: 5
        // paddingTop: Commons.isIphoneX && Commons.isIphoneX() ? 40 : Platform.select({ ios: 20, android: 24 }),
      },
      title: {
        fontSize: 16,
        color: "black",
        textAlign: "auto",
      },
      textStyle: isMobile ? {
        fontFamily: Styles.fontFamily2,
        color: 'white',
        fontSize: Styles.fontSize2,
        lineHeight: 1.6 * Styles.fontSize2,
      } : {
        ...Styles.TextStyle2,
      },
      textStyleHovered: {
        ...Styles.TextStyle2Hovered,
      },
      centerView: {
        position: "relative",
        left: 0,
        right: 0,
        // top: Platform.select({ ios: 20, android: 24 }),
        bottom: 0,
        zIndex: -1,
      },
      view: isMobile ? {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      } : {
        flexDirection: "row",
        alignItems: "center",
        gap: 40
      },
      selectedScreen: {
        // width: 60,
        borderBottomWidth: 2,
        borderBottomColor: Styles.appColor2,
      },
      nonSelectedScreen: {
        width: 0,
        borderBottomWidth: 2,
        borderBottomColor: '',
      }, textStyle2: {
        fontSize: 16,
        color: Constants.secondColor,
        fontWeight: "bold",
        margin: 15,
        fontFamily: "riposte"
      }

    };
  }
}


export default Header;
